import { createMuiTheme } from '@material-ui/core/styles';

export const colors = {
  primary: 'rgb(241, 72, 72)',
  secondary: 'rgb(241, 57, 87)',
  highlight: 'rgb(241, 210, 57)',
  grey: {
    dark: 'rgb(51, 51, 51)',
    main: 'rgb(102, 102, 102)',
    light: 'rgb(204, 204, 204)',
  },
};

export const theme = createMuiTheme({
  palette: {
    common: {},
    grey: {},
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    text: {
      primary: 'rgb(51, 51, 51)',
      secondary: 'rgb(255, 255, 255)',
    },
    getContrastText: (background) => {
      return background;
    },
  },
  typography: {
    allVariants: {
      margin: '0.5em 0',
    },
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 600,
    h1: {
      lineHeight: '56px',
      fontSize: 48,
      fontWeight: 300,
      fontFamily: 'Raleway',
      margin: '16px 0',
    },
    h2: {
      lineHeight: '56px',
      fontSize: 40,
      fontWeight: 400,
      fontFamily: 'Raleway',
      margin: '8px 0',
    },
    h3: {
      lineHeight: '32px',
      fontSize: 24,
      fontWeight: 400,
      fontFamily: 'Raleway',
      margin: '8px 0',
    },
    body1: {
      lineHeight: '24px',
      fontSize: 16,
      fontWeight: 400,
      fontFamily: 'Raleway',
      margin: 0,
    },
    body2: {
      lineHeight: '16px',
      fontSize: 14,
      fontWeight: 600,
      fontFamily: 'Raleway',
      margin: 0,
    },
    subtitle1: {
      lineHeight: '16px',
      fontSize: 14,
      fontWeight: 400,
      fontFamily: 'Raleway',
      margin: 0,
    },
    button: {
      height: '40px',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: '20px',
        fontSize: 12,
        fontWeight: 600,
      },
      containedPrimary: {},
      containedSecondary: {
        backgroundColor: '#fff',
        color: '#333',
        '&:hover': {
          backgroundColor: '#fafafa',
        },
      },
      contained: {
        boxShadow: '1px 1px 3px 0px rgba(0, 0, 0, 0.025)',
        '&:hover': {
          boxShadow: '2px 2px 5px 0px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiFormLabel: {
      root: {
        color: colors.grey.main,
        margin: 0,
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        color: colors.grey.main,
        '&$checked': {
          color: colors.primary,
        },
      },
      colorSecondary: {
        color: colors.grey.main,
        '&$checked': {
          color: colors.primary,
        },
      },
    },
  },
});
